import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { CapitalizeFirstLetter } from '@cdab/headless-components'
import { TdsNavigationTab, TdsNavigationTabs } from '@scania/tegel-react'

import { LinkTab } from '@cdab/scania/qpr/components/atoms'
import { useFeatures } from '@cdab/scania/qpr/feature-flags'
import type { TdsNavigationTabsCustomEvent } from '@scania/tegel'
import type { ReportsPageTabsProps } from './reports-page-tabs.types'

export function ReportsPageTabs(props: ReportsPageTabsProps) {
  const { t } = useTranslation(['reports', 'common'])
  const location = useLocation()

  const { statistics_report } = useFeatures(['statistics_report'])
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const tabRoutes = [
    props.links.areaSummary,
    props.links.countrySummary,
    props.links.topMarketDeviations
  ]

  useEffect(() => {
    const currentIndex = tabRoutes.findIndex(
      route => location.pathname.includes(route) || location.pathname === route
    )
    if (currentIndex !== -1) {
      setSelectedTabIndex(currentIndex)
    }
  }, [location.pathname])

  const handleTabChange = (
    e: TdsNavigationTabsCustomEvent<{
      selectedTabIndex: number
    }>
  ) => {
    const newIndex = e.detail.selectedTabIndex
    setSelectedTabIndex(newIndex)
  }

  return (
    <TdsNavigationTabs
      selectedIndex={selectedTabIndex}
      onTdsChange={handleTabChange}
    >
      <TdsNavigationTab>
        <LinkTab to={props.links.areaSummary}>
          <CapitalizeFirstLetter>
            {t('area-summary', { ns: 'reports' })}
          </CapitalizeFirstLetter>
        </LinkTab>
      </TdsNavigationTab>

      <TdsNavigationTab>
        <LinkTab to={props.links.countrySummary}>
          <CapitalizeFirstLetter>
            {t('country-summary', { ns: 'reports' })}
          </CapitalizeFirstLetter>
        </LinkTab>
      </TdsNavigationTab>

      <TdsNavigationTab>
        <LinkTab to={props.links.topMarketDeviations}>
          <CapitalizeFirstLetter>
            {t('top-market-deviations', { ns: 'reports' })}
          </CapitalizeFirstLetter>
        </LinkTab>
      </TdsNavigationTab>
      {statistics_report.enabled && (
        <TdsNavigationTab>
          <LinkTab to={props.links.statistics}>
            <CapitalizeFirstLetter>
              {t('statistics', { ns: 'reports' })}
            </CapitalizeFirstLetter>
          </LinkTab>
        </TdsNavigationTab>
      )}
    </TdsNavigationTabs>
  )
}
